import { motion } from "framer-motion";
import { Drop } from "@phosphor-icons/react";

const fadeUp = { hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0, transition: { duration: 0.6 } } };
const stagger = { visible: { transition: { staggerChildren: 0.1 } } };

const sprayMasterProducts = [
  { model: "SM-PMB", name: "Polymer Modified Bitumen Plant", image: "/images/spraymaster/sm-pmb.jpg",
    specs: ["Polymer modified plants with capacities of 15, 20, 30 & 40TPH", "Thermal Oil heated", "Automatic polymer dosing system", "160KW High shear mill"] },
  { model: "SM-BEP", name: "Bitumen Emulsion Plant", image: "/images/spraymaster/sm-bep.jpg",
    specs: ["Bitumen emulsion plants with capacities of 6 & 15TPH", "Thermal Oil heated", "Stainless steel water acid emulsifier tank", "Acid emulsifier weighing hopper on load cells", "Thermostatic controlled stainless steel heating coils"] },
  { model: "SM-BT", name: "Bitumen/Emulsion Tanks", image: "/images/spraymaster/sm-bt.jpg",
    specs: ["Capacities from 11,000, 30,000 & 38,000L", "Thermal Oil Heated with Oil heaters & heating coils", "Optional Agitators for stirring", "All pipe work, valves and accessories included", "Static or mobile / Horizontal or vertical", "Stainless steel lagged with rockwool insulation"] },
  { model: "SM-HBS", name: "Handheld Bitumen Sprayer", image: "/images/spraymaster/sm-hbs.jpg",
    specs: ["Cost effective solution", "Compact design with high mobility", "Supports 1 x 210L drums"] },
  { model: "SM-TOH", name: "Thermal Oil Heater", image: "/images/spraymaster/sm-toh.jpg",
    specs: ["Double Helix heating coil design", "High-capacity thermal oil circulation pumps", "Thermostatic controller for controlling oil temperature"] },
  { model: "SM-DMU", name: "Decanter/Drum Melting Unit", image: "/images/spraymaster/sm-dmu.jpg",
    specs: ["6-9t/h Capacity subject to ambient conditions", "20-30 Drums loading capacity (depending on model)", "Thermal oil heated helical gear bitumen pump and filter integrated", "Also used for melting other highly viscous materials in all standard drums"] },
];

export default function BitumenEquipment() {
  return (
    <div>
      <section className="relative py-24 lg:py-32 bg-[#0B2D2D] overflow-hidden" data-testid="equipment-hero">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
              <p className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-[#A7D129] mb-4">Products / Bitumen Equipment</p>
              <h1 className="font-heading font-black text-4xl md:text-6xl tracking-tight text-white leading-[1.05] mb-6">SprayMaster Equipment Range</h1>
              <p className="text-lg text-[#E0F5F2]/70 max-w-lg leading-relaxed">Professional bitumen handling and processing equipment. Complete solutions for emulsion production, storage, heating, and application.</p>
            </motion.div>
            <motion.div className="flex justify-center lg:justify-end" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8, delay: 0.3 }}>
              <div className="bg-white rounded-sm p-8 lg:p-12 shadow-2xl">
                <img src="/images/spraymaster/sm-logo.png" alt="SprayMaster Logo" className="h-24 lg:h-32 w-auto object-contain" data-testid="spraymaster-logo" />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-28 bg-white" data-testid="spraymaster-products">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <motion.div className="space-y-10" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={stagger}>
            {sprayMasterProducts.map((prod, i) => (
              <motion.div key={i} variants={fadeUp} className="card-clean rounded-sm overflow-hidden" data-testid={`spraymaster-product-${i}`}>
                <div className="grid grid-cols-1 lg:grid-cols-12">
                  <div className="lg:col-span-5 img-zoom">
                    <img src={prod.image} alt={prod.name} className="w-full h-full min-h-[320px] object-cover" loading="lazy" />
                  </div>
                  <div className="lg:col-span-7 p-8 lg:p-10 flex flex-col justify-center">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 bg-[#00A091] rounded-sm flex items-center justify-center"><Drop size={20} weight="duotone" className="text-white" /></div>
                      <div>
                        <p className="font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-[#00A091]">{prod.model}</p>
                        <h3 className="font-heading font-bold text-2xl text-[#0B2D2D]">{prod.name}</h3>
                      </div>
                    </div>
                    <div className="space-y-2.5 mt-2">
                      {prod.specs.map((spec, j) => (
                        <motion.div key={j} initial={{ opacity: 0, x: 10 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: j * 0.05 }} className="flex items-start gap-3">
                          <div className="w-1.5 h-1.5 bg-[#A7D129] rounded-full mt-2 flex-shrink-0" />
                          <span className="text-sm text-[#0B2D2D]/70 leading-relaxed">{spec}</span>
                        </motion.div>
                      ))}
                    </div>
                    <div className="mt-6 pt-4 border-t border-gray-100">
                      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#00A091] font-bold">Contact us for pricing and specifications</span>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
    </div>
  );
}
